module.exports = __webpack_public_path__ + "img/commissions_image.12a68597.jpg";